import JSZip from "jszip";
import type { Nullable } from "../types";
import { download } from "./download";

interface UrlItem {
	url: Nullable<string>;
	fileName?: string;
}

/**
 * This function downloads multiple files as a zip archive.
 * @param urls
 * @param zipName
 */
export async function downloadZip(urlItems: UrlItem[], zipName = "archive.zip") {
	const zip = new JSZip();

	async function fetchAndAddFile(item: UrlItem) {
		if (!item.url) {
			throw new Error("URL is required to download the file.");
		}
		const response = await fetch(item.url);
		if (!response.ok) throw new Error(`Failed to fetch ${item.url}`);
		const blob = await response.blob();
		zip.file(`export/${item.fileName}`, blob);
	}

	await Promise.all(urlItems.map(fetchAndAddFile));

	const zipBlob = await zip.generateAsync({ type: "blob" });

	const zipFile: File = new File([zipBlob], zipName, { type: "application/zip" });
	await download(zipFile as Nullable<File>);
}
